export default {
    heroTitle: "Le tremplin vers votre avenir international",
    heroDescription: "Préparez l'IELTS, le TOEFL, le TCF France et le TCF Canada grâce à des tests blancs, des ressources expertes et un suivi de vos progrès — tout en un seul endroit.",
    primaryCallToActionLabel: "Préparez-vous avec LinguaScore",
    primaryCallToActionLabelAlt: "Commencez votre préparation",
    secondaryCallToActionLabel: "Voir les tarifs",
    footerCallToActionTitle: "Prêt à commencer votre parcours ?",
    footerCallToActionDescription: "Rejoignez LinguaScore et accédez aux tests blancs, aux ressources et au suivi de vos progrès.",
    footerCallToActionPrimaryButtonLabel: "Créer un compte gratuit",
    footerCallToActionSecondaryButtonLabel: "Se connecter",
}
